import { environment } from '../../../../../environments/environment';
import * as i0 from "@angular/core";
export class TokenInterceptorService {
    constructor() { }
    intercept(request, next) {
        if (request.url.includes(environment.photosAPI) || request.url.includes('news')) {
            return next.handle(request);
        }
        const req = request.clone({
            headers: request.headers.append("Client-Security-Token", "8a9aeaee-69b6-4d7b-81fa-8ca3f93adb6c")
        });
        return next.handle(req);
    }
}
TokenInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TokenInterceptorService_Factory() { return new TokenInterceptorService(); }, token: TokenInterceptorService, providedIn: "root" });
